export default __webpack_public_path__ + "static/media/wasserette.26c7ce91.svg";